
define('known/collections/leaguePositionCollection',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/leaguePositionModel'
], function($, _, Backbone, LeaguePositionModel){
	var LeaguePositionCollection = Backbone.Collection.extend({
		model : LeaguePositionModel,
		leagueId : null, //Populate this on construction
		//leagueInstanceId : null, //Populate this on construction
		prodLgName : null,
	
		url: function() {
			return '/draftapp/leagues/' + this.leagueId + '/league-instances/' + this.leagueInstanceId.get('id') + '/positions';
		},
		
		initialize: function(models, options) {
			this.leagueId = options.leagueId;
			this.prodLgName = options.prodLgName;
			//this.leagueInstanceId = options.leagueInstanceId;
	    },
	    
	    getPosTypeMap: function() {
	    	if(this.posTypeMap != null){
	    		return this.posTypeMap;
	    	}
	    	
	    	this.posTypeMap = {};
	    	this.each(function(pos) {
	    		var lgPosArr = pos.get('positions');
	    		
	    		for (var i = 0; i < lgPosArr.length; i++) {
					var curPos = lgPosArr[i];
	    			
					if(this.posTypeMap[curPos] == null){
						this.posTypeMap[curPos] = [pos.get('id')];
					} else {
						this.posTypeMap[curPos].push(pos.get('id'));
					}
				}
			}, this);
	    	
	    	return this.posTypeMap;
	    },
	    
	    getLgPositionsForType: function(type) {
	    	return this.getPosTypeMap()[type];
	    },
	    
	    //Sort by a predetermined ranking of draft statuses: STARTED, PREDRAFT, SETUP, COMPLETED
		comparator : function(pos, compPos) {
			if(this.prodLgName == 'NFL'){
				if(pos.get('starters') > 0 && compPos.get('starters') == 0){
					return -1;
				} else if(compPos.get('starters') > 0 && pos.get('starters') == 0){
					return 1;
				} else if(pos.get('positions').length == 1 && compPos.get('positions').length > 1){
					return -1;
				} else if(compPos.get('positions').length == 1 && pos.get('positions').length > 1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'QB', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'QB', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'RB', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'RB', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'WR', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'WR', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'TE', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'TE', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'PK', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'PK', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'DEF', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'DEF', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'DL', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'DL', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'LB', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'LB', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'DB', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'DB', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'HC', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'HC', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'P', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'P', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'OL', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'OL', false) > -1) {
					return 1;
				} else {
					return -1;
				}
			} else if(this.prodLgName == 'MLB'){
				if(pos.get('starters') > 0 && compPos.get('starters') == 0){
					return -1;
				} else if(compPos.get('starters') > 0 && pos.get('starters') == 0){
					return 1;
				//} else if(pos.get('positions').length == 1 && compPos.get('positions').length > 1){
				//	return -1;
				//} else if(compPos.get('positions').length == 1 && pos.get('positions').length > 1) {
				//	return 1;
				} else if(pos.get('name') != 'FLEX' && compPos.get('name') == 'FLEX'){
					return -1;
				} else if(compPos.get('name') != 'FLEX' && pos.get('name') == 'FLEX') {
					return 1;
				//Absolute positioning by name
				} else if(pos.get('name') == 'C') {
					return -1;
				} else if(compPos.get('name') == 'C') {
					return 1;
				} else if(pos.get('name') == '1B') {
					return -1;
				} else if(compPos.get('name') == '1B') {
					return 1;
				} else if(pos.get('name') == '2B') {
					return -1;
				} else if(compPos.get('name') == '2B') {
					return 1;
				} else if(pos.get('name') == '3B') {
					return -1;
				} else if(compPos.get('name') == '3B') {
					return 1;
				} else if(pos.get('name') == 'SS') {
					return -1;
				} else if(compPos.get('name') == 'SS') {
					return 1;
				} else if(pos.get('name') == 'CI') {
					return -1;
				} else if(compPos.get('name') == 'CI') {
					return 1;
				} else if(pos.get('name') == 'MI') {
					return -1;
				} else if(compPos.get('name') == 'MI') {
					return 1;
				} else if(pos.get('name') == 'LF') {
					return -1;
				} else if(compPos.get('name') == 'LF') {
					return 1;
				} else if(pos.get('name') == 'CF') {
					return -1;
				} else if(compPos.get('name') == 'CF') {
					return 1;
				} else if(pos.get('name') == 'RF') {
					return -1;
				} else if(compPos.get('name') == 'RF') {
					return 1;
				} else if(pos.get('name') == 'OF') {
					return -1;
				} else if(compPos.get('name') == 'OF') {
					return 1;
				} else if(pos.get('name') == 'DH') {
					return -1;
				} else if(compPos.get('name') == 'DH') {
					return 1;
				} else if(pos.get('name') == 'UTIL') {
					return -1;
				} else if(compPos.get('name') == 'UTIL') {
					return 1;
				} else if(pos.get('name') == 'SP') {
					return -1;
				} else if(compPos.get('name') == 'SP') {
					return 1;
				} else if(pos.get('name') == 'RP') {
					return -1;
				} else if(compPos.get('name') == 'RP') {
					return 1;
				} else if(pos.get('name') == 'P') {
					return -1;
				} else if(compPos.get('name') == 'P') {
					return 1;
				} else if(pos.get('name') == 'HC') {
					return -1;
				} else if(compPos.get('name') == 'HC') {
					return 1;
					
					
				//Used for Flex:
				} else if(_.indexOf(pos.get('positions'), 'C', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'C', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), '1B', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), '1B', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), '2B', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), '2B', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), '3B', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), '3B', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'SS', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'SS', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'LF', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'LF', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'CF', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'CF', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'RF', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'RF', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'OF', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'OF', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'DH', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'DH', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'UTIL', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'UTIL', false) > -1) {
					return 1;
				}else if(_.indexOf(pos.get('positions'), 'SP', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'SP', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'RP', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'RP', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'P', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'P', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'HC', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'HC', false) > -1) {
					return 1;
				} else {
					return -1;
				}
			} else if(this.prodLgName == 'NBA'){
				if(pos.get('starters') > 0 && compPos.get('starters') == 0){
					return -1;
				} else if(compPos.get('starters') > 0 && pos.get('starters') == 0){
					return 1;
				} else if(pos.get('positions').length == 1 && compPos.get('positions').length > 1){
					return -1;
				} else if(compPos.get('positions').length == 1 && pos.get('positions').length > 1) {
					return 1;
				} else if(pos.get('name') == 'G') {
					return -1;
				} else if(compPos.get('name') == 'G') {
					return 1;
				} else if(pos.get('name') == 'F') {
					return -1;
				} else if(compPos.get('name') == 'F') {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'PG', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'PG', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'SG', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'SG', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'SF', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'SF', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'PF', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'PF', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'C', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'C', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'HC', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'HC', false) > -1) {
					return 1;
				} else {
					return -1;
				}
			} else if(this.prodLgName == 'NHL'){
				if(pos.get('starters') > 0 && compPos.get('starters') == 0){
					return -1;
				} else if(compPos.get('starters') > 0 && pos.get('starters') == 0){
					return 1;
				} else if(pos.get('name') == 'F') {
					return -1;
				} else if(compPos.get('name') == 'F') {
					return 1;
				} else if(pos.get('positions').length == 1 && compPos.get('positions').length > 1 && compPos.get('name') != 'F'){
					return -1;
				} else if(compPos.get('positions').length == 1 && pos.get('positions').length > 1 && pos.get('name') != 'F') {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'C', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'C', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'LW', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'LW', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'RW', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'RW', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'D', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'D', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'G', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'G', false) > -1) {
					return 1;
				} else if(_.indexOf(pos.get('positions'), 'HC', false) > -1) {
					return -1;
				} else if(_.indexOf(compPos.get('positions'), 'HC', false) > -1) {
					return 1;
				} else {
					return -1;
				}
			}
		}
	});
	
	return LeaguePositionCollection;  
});